import script from "./Menu.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=45c55694&lang=css"

const __exports__ = script;

export default __exports__